
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import EmojiInput from '../input/Emoji.vue'

type InputMeta = {
  lastFocus: 'input' | 'textarea'
}

@Observer
@Component({
  components: { EmojiInput }
})
export default class EditorContent extends Vue {
  @Prop({ required: true }) title: string

  @Prop({ required: true }) required: boolean

  @Prop({ required: true }) textLimit: number

  @Prop({ required: true }) publishDisabled: boolean

  @Prop({ required: true }) contentPlaceholder: string

  @Prop({ required: false, default: false }) loading: boolean

  @Prop({ required: false }) contentType: string

  @Ref()
  input: { $el: HTMLInputElement }

  @Ref()
  textarea: { $el: HTMLTextAreaElement }

  isPublic: boolean = true

  inputMeta: InputMeta = {
    lastFocus: 'input'
  }

  userInputTitle = ''
  userInputContent = ''

  get submitBtnDisable() {
    // 如果是日记提交的情况，图片和内容有一个存在就可以提交（不考虑required是否必填的判断）
    if (this.contentType === 'dairy' || this.contentType === 'guild') {
      return this.publishDisabled && this.userInputContent.trim().length === 0
    }
    return this.publishDisabled || (this.required && this.userInputContent.trim().length === 0)
  }

  // export
  getFormStatus() {
    return {
      hasTitle: this.userInputTitle.length !== 0,
      hasContent: this.userInputContent.length !== 0
    }
  }

  handleSelectEmoji(emoji: string) {
    if (this.loading) return

    if (this.inputMeta.lastFocus === 'input') {
      const start = this.input.$el.selectionStart || 0
      this.userInputTitle = this.userInputTitle.slice(0, start) + emoji + this.userInputTitle.slice(start)

      this.$nextTick(() => {
        this.input.$el.setSelectionRange(start + emoji.length, start + emoji.length)
        this.input.$el.focus()
      })
    } else {
      const start = this.textarea.$el.selectionStart

      this.userInputContent = this.userInputContent.slice(0, start) + emoji + this.userInputContent.slice(start)

      this.$nextTick(() => {
        this.textarea.$el.setSelectionRange(start + emoji.length, start + emoji.length)
        this.textarea.$el.focus()
      })
    }
  }

  handleSwitchPublic() {
    if (this.loading) return

    this.isPublic = !this.isPublic
  }

  handleInputFocus(event: InputEvent) {
    this.inputMeta.lastFocus = 'input'
  }

  handleTextareaFocus(event: InputEvent) {
    this.inputMeta.lastFocus = 'textarea'
  }

  handleSubmit() {
    this.$emit('submit', {
      title: this.userInputTitle,
      content: this.userInputContent,
      isPublic: this.isPublic
    })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
